export default function registerFilters (Vue) {
  // Filtro de texto -> length = máximo de caracteres
  Vue.filter('truncate', function (value, length) {
    if (value.length < length) {
      return value
    }

    length = length - 3
    return value.substring(0, length) + '...'
  })

  // Filtro de hora -> 02:00:00 to 02:00am | 16:00:00 to 04:00pm
  Vue.filter('hour', function (value) {
    if (value) {
      const time = value.split(':')
      let hour
      let hourName

      if (parseInt(time[0], 10) > 12) {
        hour = parseInt(time[0], 10) % 12
        hourName = 'pm'
      } else {
        hour = parseInt(time[0], 10)
        hourName = 'am'
      }
      hour = hour < 10 ? '0' + hour : hour
      return hour + ':' + time[1] + hourName
    } else {
      return value
    }
  })

  // Filtro de fecha -> 2016-01-01 to 01/01/2016
  Vue.filter('reverseDate', function (value) {
    if (value) {
      return value.split('-').reverse().join('/')
    } else {
      return value
    }
  })

  // Filtro de fecha -> Dia(01) | Mes(ene) | Año(2016) | Fecha Completa(01 de Enero del 2016)
  Vue.filter('date', function (value, datetype) {
    if (value) {
      const date = value.split('-').reverse()
      const monthNumber = parseInt(date[1], 10)
      let monthName
      let monthNameFull
      switch (monthNumber) {
        case 1:
          monthName = 'ene'
          monthNameFull = 'Enero'
          break
        case 2:
          monthName = 'feb'
          monthNameFull = 'Febrero'
          break
        case 3:
          monthName = 'mar'
          monthNameFull = 'Marzo'
          break
        case 4:
          monthName = 'abr'
          monthNameFull = 'Abril'
          break
        case 5:
          monthName = 'may'
          monthNameFull = 'Mayo'
          break
        case 6:
          monthName = 'jun'
          monthNameFull = 'Junio'
          break
        case 7:
          monthName = 'jul'
          monthNameFull = 'Julio'
          break
        case 8:
          monthName = 'ago'
          monthNameFull = 'Agosto'
          break
        case 9:
          monthName = 'sep'
          monthNameFull = 'Septiembre'
          break
        case 10:
          monthName = 'oct'
          monthNameFull = 'Octubre'
          break
        case 11:
          monthName = 'nov'
          monthNameFull = 'Noviembre'
          break
        case 12:
          monthName = 'dic'
          monthNameFull = 'Diciembre'
          break
      }
      switch (datetype) {
        case 'day':
          return date[0]
        case 'month':
          return monthName
        case 'year':
          return date[2]
        case 'short':
          return date[0] + ', ' + monthName + ' ' + date[2]
        default:
          return date[0] + ' de ' + monthNameFull + ' del ' + date[2]
      }
    } else {
      return value
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/config/registerFilters.js